










































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import pmd_arboles_problema from '@/mixins/axios/pmd_arboles_problema'

//@ts-ignore
import poas from '@/mixins/axios/poas'
//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
            
            
             {
                tag:'idarboledit',
                data:'idarboledit',
                active:true
            },
             {
                tag:'idobjetivos',
                data:'idobjetivos',
                active:true
            },
            {
                tag:'idmir',
                data:'idmir',
                active:true
            },
            {
                tag:'idpoa',
                data:'idpoa',
                active:true

            },
           
        /*    {
                tag:'identificacion',
                data:'identificacion',
                active:true
            },
            {
                tag:'problema',
                data:'problema',
                active:true
            },*/
            {
                tag:'departamento',
                data:'departamento',
                active:true
            },
           
            {
                tag:'secretaria',
                data:'secretaria',
                active:true
            },
             {
               tag:'imprimirArbol',
               data:'imprimirArbol',
                active:false
           },
            
             {
                tag:'delete',
                data:'delete',
                active:false
            },
           
             
            
           
        ],
        
              arbol_data:[] as any,
      
    }
  },
     mixins: [pmd_arboles_problema,poas],
     validations: {},
  methods:{


 async verpoa(row){
     
    
this.$root.$emit('loading', true);

let data= await this.GET_POASHOW({id:row.idpoa}).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
    this.$store.commit('SETPOA',response);
    
    this.$router.push('/mun/poa/poas/lineas')
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });


 // this.$store.commit('SETMIR',data);
//this.$router.push('/mun/pmd/mirbuilderv1?type=editar')
      },

      vermir(row){
          let data={
    idmir:row.idmir
    }
  this.$store.commit('SETMIR',data);
this.$router.push('/mun/pmd/mirbuilderv1?type=editar')
      },
      viewArbol(row){
console.log(row)

    this.$store.commit('SETPROBLEMA',row);
    this.$router.push('/mun/poa/builder?type=edit');
      },


exportarPdf(row){
 this.$store.commit('SETPROBLEMA',row);
    this.$router.push('/mun/pmd/viewerPdfArboles');
},


      viewArbolObjetivos(row){
          console.log('rowww-----')
console.log(row)
console.log('rowew--')
if(row.idobjetivos==null){
    this.$store.commit('SETPROBLEMA',row);
    this.$router.push('/mun/pmd/objetivosbuilder?type=crear');
    return;
}

    this.$store.commit('SETPROBLEMA',row);
    this.$router.push('/mun/pmd/objetivosbuilder?type=edit');
      },
       addRow() {
      
 this.$router.push('/mun/poa/builder?type=crear')
     
    },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
    idmunicipio:this.$store.state.user.usuario.id_municipio,
    //   idsecretaria:this.$store.state.secretaria_sel.id,
     // iddepartamento:this.$store.state.departamento_sel.id,

};

let data= await this.GET_PMD_ARBOLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.arbol_data=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

